var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadableReady } from '@loadable/component';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { TrelloClientProvider, TrelloClient, CookiePreferencesProvider, CookieLanguageProvider } from '@bxp-spaces/trello';
import { App, APP_ID } from '@atlassian/bxp-content-app';
loadableReady(() => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    const container = document.getElementById(APP_ID);
    if (container) {
        const baseURL = (_b = (_a = document.getElementById('BXP_BASE_URL')) === null || _a === void 0 ? void 0 : _a.getAttribute('href')) !== null && _b !== void 0 ? _b : '';
        const json = (_c = document.getElementById('BXP_PAGE_MODEL')) === null || _c === void 0 ? void 0 : _c.innerHTML;
        const { trelloClientBaseUrl } = JSON.parse((_e = (_d = document.getElementById('BXP_CONFIG')) === null || _d === void 0 ? void 0 : _d.innerHTML) !== null && _e !== void 0 ? _e : '{}');
        if (json) {
            ReactDOM.hydrate(React.createElement(CookieLanguageProvider, null,
                React.createElement(CookiePreferencesProvider, null,
                    React.createElement(BrowserRouter, { basename: baseURL },
                        React.createElement(TrelloClientProvider, { client: new TrelloClient({ baseUrl: trelloClientBaseUrl }) },
                            React.createElement(App, { defaultPageModel: JSON.parse(json) }))))), container);
        }
        else {
            throw new Error('Could not find page model.');
        }
    }
    else {
        throw new Error(`Could not find container with id: ${APP_ID}`);
    }
})).catch(console.error);
//# sourceMappingURL=main.js.map